<template>
  <div class="terms-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h2 class="subtitle">{{ terms.title }}</h2>
          <div v-html="terms.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TermsAndConditions',
  computed: {
    terms() {
      return this.$store.getters.getTermsOfServices;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getTermsOfServices');
  },
};
</script>

<style scoped>
.terms-section {
    padding: 3rem 0 3rem;
    font-size: 1.5rem;
    line-height: 2;
}
</style>
